import { render, staticRenderFns } from "./SessionsWoStudentFeedback.vue?vue&type=template&id=12dc809d"
import script from "./SessionsWoStudentFeedback.vue?vue&type=script&lang=js"
export * from "./SessionsWoStudentFeedback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports